import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';

import { BaseButtonDirective } from '../../base-button';
import { ExtendableButton, RtButtonVariant } from '../../button.types';

@Component({
  selector: `rt-button-new, a[rt-button-new]`,
  templateUrl: './button.component.html',
  styleUrls: [
    '../../styles/base.less',
    './button.component.less',
    '../../directives/button-loading/button-loading.directive.less',
    '../../directives/button-dropdown/button-dropdown-indicator.directive.less',
  ],
  // eslint-disable-next-line
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: ExtendableButton, useExisting: ButtonNewComponent }],
})
export class ButtonNewComponent extends BaseButtonDirective implements ExtendableButton {
  @Input() public variant: RtButtonVariant = 'secondary';

  @ViewChild('primarySlot', { static: true, read: ViewContainerRef })
  public primarySlot: ViewContainerRef;
  @ViewChild('secondarySlot', { static: true, read: ViewContainerRef })
  public secondarySlot: ViewContainerRef;
}
